import React, { useState, useEffect } from 'react';

import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalEmpty';
import { WithApp } from 'contexts/appContext';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';

import { makeStyles } from '@material-ui/core/styles';
import { Autocomplete } from '@material-ui/lab';
import moment from 'moment';

// import DetailKardex from './DetailKardex';
import { useToasty } from 'hooks/Toasty';
import { wsUpdate, wsCreate } from 'services/WService';
import { useLocation, useParams } from 'react-router-dom';

const useStyles = makeStyles({
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px',
    fontWeight: 'bold'
  }
});

function useQuery() {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
}

const comboEntry = [
  { field: 'A', label: 'Entrada1' },
  { field: 'B', label: 'Entrada2' }
];

const comboOutput = [
  { field: 'TSI', label: 'Interna' },
  { field: 'TSE', label: 'Externa' }
];

export default WithApp(function ModalOuput(props) {
  const classes = useStyles();
  const { open, onClose, data, getTransfer } = props;
  const [notify, showNotify] = useToasty();
  const { 
    type, warehouseId, warehouseName, idRegister, products = [],
    zoneId, zoneName, auditor,almacenero, jefeDia, jefeNoche 
  } = data || {};
  // const type = useQuery().get('type');
  const title = type === 'ET' ? 'entrada' : 'salida';
  const entity = type === 'ET' ? 'logi/entry' : 'logi/output';
  const { id } = useParams();

  const defaultData = {
    TaxDate: moment().format('YYYY-MM-DD'),
    DocDate: moment().format('YYYY-MM-DD'),
    logi_warehouse_id: warehouseId || '',
    base_zone_description: zoneName || '',
    JrnlMemo: type === 'ET' ? 'Entrada de mercadería' : 'Salida de mercadería',
    [type === 'ET' ? 'U_SYP_TPOENTME' : 'U_SYP_MDTS']: type === 'ET' ? 'A' : 'TSI',
  };
  const [dataHeader, setDataHeader] = useState(defaultData);
  const [createdId, setCreatedId] = useState(null);
  const [stateK, setStateK] = useState(false); // estado del kardex (state_migrate)

  const handleChangeHeader = (e) => {
    setDataHeader({ ...dataHeader, [e.target.name]: e.target.value });
  };

  async function updateEntryOutput(idRegister, dataEntryOutput) {
    let response = await wsUpdate(`logi/inventory/${idRegister}/update-exits`, dataEntryOutput);
    
    if (response.success) {
      getTransfer(idRegister);
      showNotify(response.message);
    } else {
      showNotify(response.message, 'error');
    }
  }
  async function saveDetail(createdId, productSelected) {
    const data = {
      logi_product_id: productSelected.logi_product_id,
      quantity: productSelected.quantity
    };
  
    if (!data.quantity || data.quantity <= 0) {
      showNotify('Ingrese una cantidad válida', 'info');
      return;
    }
    const detail_create = type === 'ET' ? 'detail' : 'create-detail';
    let response = await wsCreate(`${entity}/${createdId}/${detail_create}`, data);
    if (response.success) {
      showNotify(response.message);
    } else {
      showNotify(response.message, 'error');
    }
  }
  async function changeStateK(newId, state) {
    const state_new = type === 'ET' ? 'change-state' : 'change-validate';
    let response = await wsUpdate(`${entity}/${newId}/${state_new}`, {
      state_migrate: state
    });
    const dataEntryOutput = {
      [type === 'ET' ? 'logi_entry_id' : 'logi_output_id'] : newId || null,
    };
    updateEntryOutput(data.idRegister, dataEntryOutput);
    if (response.success) {
      return response;
    } else {
      return response;
    }
  }
  

  useEffect(() => {
    setDataHeader((prev) => ({
      ...prev,
      logi_warehouse_id: warehouseId,
      base_zone_description: zoneName,
      U_SYP_ALMACENERO: almacenero || '', 
      U_SYP_SOLICITANTE: auditor || '',
      TypeInventory: 'Y'
    }));
  }, [warehouseId, zoneName, auditor, jefeDia, jefeNoche]);

  return (
    <>
      <Modal 
        title={`Modal para generar nueva ${title}`}
        model={{ open: props.open }}
        setOpen={props.onClose}
        showNotify={props.showNotify}
        reload={props.reload}
        arrDataResponse
        entity={entity}
        createEntity={type === 'ET' ? undefined : `${entity}/inventory`}
        dataForce={{
          [type === 'ET' ? 'U_SYP_TPOENTME' : 'U_SYP_MDTS']: dataHeader[type === 'ET' ? 'U_SYP_TPOENTME' : 'U_SYP_MDTS'],
          base_zone_description: zoneName,
          logi_warehouse_id: dataHeader.logi_warehouse_id,
          TypeInventory: 'Y',
        }}
        setCreatedId={setCreatedId}
        saveDetail={saveDetail}
        productList={products}
        getTransfer={getTransfer}
        idRegister={idRegister}
        type={type}
        updateEntryOutput={updateEntryOutput}
        changeStateK={changeStateK}
      >
      <GridContainer>
          <GridItem xs={12} lg={2}>
            <TextField
              label="Fecha contable"
              type="date"
              name="TaxDate"
              fullWidth
              margin="normal"
              value={
                moment(dataHeader.TaxDate).format('YYYY-MM-DD') ||
                moment().format('YYYY-MM-DD') ||
                ''
              }
              onChange={handleChangeHeader}
              disabled={stateK}
            />
          </GridItem>
          <GridItem xs={12} lg={2}>
            <TextField
              label="Fecha documento"
              type="date"
              name="DocDate"
              fullWidth
              margin="normal"
              value={
                moment(dataHeader.DocDate).format('YYYY-MM-DD') || moment().format('YYYY-MM-DD')
              }
              onChange={handleChangeHeader}
              disabled={stateK}
            />
          </GridItem>
          <GridItem xs={12} lg={2}>
            <TextField
              label="Referencia"
              fullWidth
              name="Ref2"
              margin="normal"
              value={dataHeader.Ref2 || `ID: ${idRegister}`}
              onChange={handleChangeHeader}
              inputProps={{ maxLength: 11 }}
              required
              disabled={stateK}
            />
          </GridItem>
          <GridItem xs={12} lg={2}>
            <TextField
              label="Almacén"
              fullWidth
              margin="normal"
              value={warehouseName || ''}
              InputProps={{ readOnly: true }}
            />
          </GridItem>
          <GridItem xs={12} lg={2}>
            <TextField
              label="Zona"
              fullWidth
              margin="normal"
              value={zoneName || ''}
              InputProps={{ readOnly: true }}
            />
          </GridItem>
          <GridItem xs={12} lg={2}>
            <TextField
              multiline
              label="Comentario"
              fullWidth
              name="Comments"
              margin="normal"
              value={dataHeader.Comments || 'Toma de inventario'}
              onChange={handleChangeHeader}
              inputProps={{ maxLength: 127 }}
              required
              disabled={stateK}
            />
          </GridItem>
          <GridItem xs={12} lg={2}>
            <TextField
              label="Título"
              fullWidth
              name="JrnlMemo"
              margin="normal"
              value={dataHeader.JrnlMemo || ''}
              onChange={handleChangeHeader}
              inputProps={{ maxLength: 127 }}
              required
              disabled={stateK}
            />
          </GridItem>
          <GridItem xs={12} lg={2}>
            <Autocomplete
              key={stateK + (type === 'ET' ? comboEntry : comboOutput)}
              options={type === 'ET' ? comboEntry : comboOutput}
              disableClearable
              defaultValue={
                (type === 'ET' ? comboEntry : comboOutput).find(
                  (item) =>
                    item.field == dataHeader[type === 'ET' ? 'U_SYP_TPOENTME' : 'U_SYP_MDTS']
                ) || undefined
              }
              getOptionLabel={(option) => option.label}
              disabled={stateK}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={`Tipo ${type === 'ET' ? 'entrada' : 'salida'}`}
                  margin="normal"
                  required
                />
              )}
              onChange={(e, item) => {
                setDataHeader({
                  ...dataHeader,
                  [type === 'ET' ? 'U_SYP_TPOENTME' : 'U_SYP_MDTS']: item.field
                });
              }}
            />
          </GridItem>
          <GridItem xs={12} lg={2}>
            <TextField
              label="Almacenero"
              fullWidth
              name="U_SYP_ALMACENERO"
              margin="normal"
              value={dataHeader.U_SYP_ALMACENERO || ''}
              onChange={handleChangeHeader}
              required
              disabled={stateK}
            />
          </GridItem>
          <GridItem xs={12} lg={2}>
            <TextField
              label="Solicitante"
              fullWidth
              name="U_SYP_SOLICITANTE"
              margin="normal"
              value={dataHeader.U_SYP_SOLICITANTE || ''}
              onChange={handleChangeHeader}
              required
              disabled={stateK}
            />
          </GridItem>
          <GridItem xs={12} lg={3}>
            <TextField
              label="Motivo traslado"
              fullWidth
              name="U_SYP_MDMT"
              margin="normal"
              value={
                dataHeader.U_SYP_MDMT === '22' ? 'Entrada por identificación errónea' : 
                  dataHeader.U_SYP_MDMT === '23' ? 'Salida por identificación errónea' :
                  dataHeader.U_SYP_MDMT || (type === 'ET' ? 'Entrada por identificación errónea' : 'Salida por identificación errónea')
              }
              disabled
            />
          </GridItem>
        </GridContainer>
      </Modal>
    </>
  );
});
